import { render, staticRenderFns } from "./StatisticReport.vue?vue&type=template&id=676cafb8"
import script from "./StatisticReport.vue?vue&type=script&lang=js"
export * from "./StatisticReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports